import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/login.vue"),
  },
  {
    path: "/error",
    name: "Error",
    component: () => import("../views/error.vue"),
  },
  {
    path: "/not-found",
    name: "notFound",
    component: () => import("../views/not-found.vue"),
  },
  {
    path: "/",
    name: "home",
    component: () => import("../views/index.vue"),
    children: [
      {
        path: "index",
        name: "Index",
        meta: {
          title: "主页",
          affix: true,
          keepAlive: false,
        },
        component: () => import('../views/dataStatistics/dataStatistics.vue')

      },
      // 群列表
      {
        path: 'group/list',
        name: 'groupList',
        component: () => import("../views/group/list.vue"),
        meta: {
          titleParent: '群管理',
          title: '群列表',
          affix: false,
          keepAlive: false,
        }
      },
      // 群活码
      {
        path: 'group/code',
        name: 'groupCode',
        component: () => import("../views/group/groupActiveCode.vue"),
        meta: {
          titleParent: '群管理',
          title: '群活码',
          affix: false,
          keepAlive: false,
        }
      },
      // 群活码统计
      {
        path: 'group/codeStatistical',
        name: 'groupStatistics',
        component: () => import("../views/group/groupActiveCodeStatistics.vue"),
        meta: {
          titleParent: '群管理',
          title: '群活码统计',
          affix: false,
          keepAlive: false,
        }
      },
      // 群标签
      {
        path: 'group/tag',
        name: 'groupTag',
        component: () => import("../views/group/tag.vue"),
        meta: {
          titleParent: '群管理',
          title: '群标签',
          affix: false,
          keepAlive: false,
        }
      },
      // 群SOP
      {
        path: 'group/sop',
        name: 'groupSop',
        component: () => import("../views/group/sop/index.vue"),
        meta: {
          titleParent: '群管理',
          title: '群SOP',
          affix: false,
          keepAlive: false,
        }
      },
      // 群详情（菜单不显示，仅路由跳转）
      {
        path: 'group/detail',
        name: 'groupDetail',
        component: () => import("../views/group/groupDetail.vue"),
        meta: {
          title: '群详情',
          affix: false,
          keepAlive: false,
        }
      },
      // 群聊数据看板
      {
        path: 'groupChat/chat',
        name: 'groupChat',
        component: () => import("../views/groupChat/chat.vue"),
        meta: {
          titleParent: '数据中心',
          title: '群聊数据看板',
          affix: false,
          keepAlive: false,
        }
      },
      // 聊天数据看板
      {
        path: 'dataChat/chat',
        name: 'dataChat',
        component: () => import("../views/dataChat/chat.vue"),
        meta: {
          titleParent: '数据中心',
          title: '聊天数据看板',
          affix: false,
          keepAlive: false,
        },
        },
      // 商品库看板
      {
        path: 'commodityBoard/index',
        name: 'commodityBoard',
        component: () => import("../views/commodityBoard/index.vue"),
        meta: {
          titleParent: '数据中心',
          title: '商品库看板',
          affix: false,
          keepAlive: false,
        }
      },
      {
        path: 'employeeChatStatistics/index',
        name: 'employeeChatStatistics',
        component: () => import("../views/employeeChatStatistics/index.vue"),
        meta: {
          titleParent: '数据中心',
          title: '员工聊天统计',
          affix: false,
          keepAlive: false,
        }
      },

      //客户管理
      {
        path: "customer/Eamc",
        name: "Eamc",
        component: () => import("../views/customer/Eamc.vue"),
        meta: {
          titleParent: "客户管理",
          title: "企微客户",
          affix: false,
          keepAlive: false,
        },
      },
      //档案操作日志
      {
        path: "customer/fileOpLog",
        name: "fileOpLog",
        component: () => import("../views/customer/fileOpLog.vue"),
        meta: {
          titleParent: "客户管理",
          title: "档案操作日志",
          affix: false,
          keepAlive: false,
        },
      },
      {
        path: "system/Staff1",
        name: "Staff1",
        component: () => import("../views/system/Staff1.vue"),
        meta: {
          titleParent: "系统管理",
          title: "员工管理",
          affix: false,
          keepAlive: false,
        },
      },
      {
        path: "system/Role",
        name: "Role",
        component: () => import("../views/system/Role.vue"),
        meta: {
          titleParent: "系统管理",
          title: "角色管理",
          affix: false,
          keepAlive: false,
        },
      },
      // enterpriseSetting
      {
        path: "system/Setting",
        name: "Setting",
        component: () => import("../views/system/enterpriseSetting.vue"),
        meta: {
          titleParent: "系统管理",
          title: "基础设置",
          affix: false,
          keepAlive: false,
        },
      },
      {
        path: "chat/StaffChatSupervise",
        name: "StaffChatSupervise",
        component: () => import("../views/chat/StaffChatSupervise.vue"),
        meta: {
          titleParent: "聊天监管",
          title: "聊天审计-员工列表",
          affix: false,
          keepAlive: false,
        },
      },
      {
        path: "chat/chatChartSupervise",
        name: "ChatChartSupervise",
        component: () => import("../views/chat/chatChartSupervise/index.vue"),
        meta: {
          titleParent: "聊天监管",
          title: "聊天审计-沟通视图",
          affix: false,
          keepAlive: false,
        },
      },
      {
        path: "chat/CusChatSupervise",
        name: "CusChatSupervise",
        component: () => import("../views/chat/CusChatSupervise.vue"),
        meta: {
          titleParent: "聊天监管",
          title: "聊天审计-客户列表",
          affix: false,
          keepAlive: false,
        },
      },
      {
        path: "chat/SenWordStatistics",
        name: "SenWordStatistics",
        component: () => import("../views/chat/newKeyWordStatistics.vue"),
        meta: {
          titleParent: "聊天监管",
          title: "关键词统计",
          affix: false,
          keepAlive: false,
        },
      },
      {
        path: "chat/SenWordSettings",
        name: "SenWordSettings",
        component: () => import("../views/chat/SenWordSettings.vue"),
        meta: {
          titleParent: "聊天监管",
          title: "敏感词设置",
          affix: false,
          keepAlive: false,
        },
      },
      {
        path: "chat/KeyWordStatistics",
        name: "KeyWordStatistics",
        component: () => import("../views/chat/KeyWordStatistics.vue"),
        meta: {
          titleParent: "聊天监管",
          title: "关键词统计",
          affix: false,
          keepAlive: false,
        },
      },
      // 修改了这个地方  打包记得改回来  KeyWordSettings
      {
        path: "chat/KeyWordSettings",
        name: "KeyWordSettings",
        component: () => import("../views/chat/KeyWordSettings.vue"),
        meta: {
          titleParent: "聊天监管",
          title: "关键词设置",
          affix: false,
          keepAlive: false,
        },
      },
      // 敏感行为统计
      {
        path: "chat/SensitiveBehavior",
        name: "SensitiveBehavior",
        component: () => import("../views/chat/SensitiveBehavior.vue"),
        meta: {
          titleParent: "聊天监管",
          title: "敏感行为统计",
          affix: false,
          keepAlive: false,
        },
      },
      {
        path: "sensitive/SensitiveWord",
        name: "SensitiveWord",
        component: () => import("../views/sensitive/SensitiveWord.vue"),
        meta: {
          titleParent: "敏感词",
          title: "敏感词-列表",
          affix: false,
          keepAlive: false,
        },
      },
      // 敏感行为监控
      {
        path: "sensitive/behaviorMonitoring",
        name: "behaviorMonitoring",
        component: () => import("../views/sensitive/behaviorMonitoring.vue"),
        meta: {
          titleParent: "敏感词",
          title: "敏感行为监控",
          affix: false,
          keepAlive: false,
        },
      },

      {
        path: "code/StaffCode",
        name: "StaffCode",
        component: () => import("../views/code/StaffCode.vue"),
        meta: {
          titleParent: "拓客活码",
          title: "拓客活码",
          affix: false,
          keepAlive: false,
        },
      },
      {
        path: "code/StaffLabel",
        name: "StaffLabel",
        component: () => import("../views/code/StaffLabel.vue"),
        meta: {
          titleParent: "标签管理",
          title: "拓客活码-标签管理",
          affix: false,
          keepAlive: false,
        },
      },
      {
        path: "code/Welcome",
        name: "Welcome",
        component: () => import("../views/code/Welcome.vue"),
        meta: {
          titleParent: "欢迎语管理",
          title: "拓客活码-欢迎语管理",
          affix: false,
          keepAlive: false,
        },
      },

      // 待更改前
      {
        path: "code/CusManage",
        name: "CusManage",
        component: () => import("../views/code/CusManage.vue"),
        meta: {
          titleParent: "客户管理",
          title: "客户管理",
          affix: false,
          keepAlive: false,
        },
      },
      {
        path: "code/Statistics",
        name: "Statistics",
        component: () => import("../views/code/Statistics.vue"),
        meta: {
          titleParent: "活码统计",
          title: "活码统计",
          affix: false,
          keepAlive: false,
        },
      },
      {
        path: "code/addFriends",
        name: "addFriends",
        component: () => import("../views/code/addFriends.vue"),
        meta: {
          titleParent: "批量加好友",
          title: "批量加好友",
          affix: false,
          keepAlive: false,
        },
      },
      // 待更改后
      {
        path: "mass/customerMass",
        name: "customerMass",
        component: () => import("../views/mass/mass.vue"),
        meta: {
          titleParent: "客户跟进",
          title: "客户群发",
          affix: false,
          keepAlive: false,
        }
      },
      {
        path: "mass/marketingRadar",
        name: "marketingRadar",
        // component: () => import("../views/mass/mass.vue"),
        meta: {
          titleParent: "客户跟进",
          title: "营销雷达",
          affix: false,
        },
        children: [
      {
        path: "mass/marketingRadar/cluePoll",
        name: "cluePoll",
        meta: {
          title: "线索池",
          keepAlive: false,
        },
        component: () => import('../views/marketingRadar/cluePool/index.vue')

      },
      {
        path: "mass/marketingRadar/followUp",
        name: "followUp",
        meta: {
          title: "跟进任务",
          keepAlive: false,
        },
        component: () => import('../views/marketingRadar/followUp/index.vue')

      },
      {
        path: "mass/marketingRadar/statistics",
        name: "statistics",
        meta: {
          title: "转化效果",
          keepAlive: false,
        },
        component: () => import('../views/marketingRadar/statistics/index.vue')

      },
      ]
      },
      {
        path: "mass/materialManagement",
        name: "materialManagement",
        component: () => import("../views/mass/MaterialManagement.vue"),
        meta: {
          titleParent: "客户跟进",
          title: "素材库管理",
          affix: false,
          keepAlive: false,
        },
      },
      {
        path: "mass/scriptLibrary",
        name: "scriptLibrary",
        component: () => import("../views/mass/scriptLibrary/index.vue"),
        meta: {
          titleParent: "客户跟进",
          title: "话术库",
          affix: false,
          keepAlive: false,
        },
      },
      {
        path: "mass/customerSOP",
        name: "customerSOP",
        component: () => import("../views/mass/SOP/CustomerSOP.vue"),
        meta: {
          titleParent: "客户跟进",
          title: "客户SOP",
          affix: false,
          keepAlive: false,
        },
      },
      {
        path: "contentCenter/index",
        name: "contentCenter",
        component: () => import("../views/contentCenter/index.vue"),
        meta: {
          titleParent: "内容中心",
          title: "商品统计",
          affix: false,
          keepAlive: false,
        },
      },
      {
        path: "knowledgeSet/index",
        name: "knowledgeSet",
        component: () => import("../views/contentCenter/knowledgeSet/index.vue"),
        meta: {
          titleParent: "内容中心",
          title: "知识集",
          affix: false,
          keepAlive: false,
        },
      },
    ],
  },
  {
    path: "*",
    name: "Login",
    component: () => import("../views/login.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
  base: "/qwadmin/",
});

// router.beforeEach(function (to,from,next) {

// })
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

export default router;